class MiscUtil {
  // tslint:disable-next-line:no-any
  public static IsNullOrUndefined(o?: any): o is (null | undefined) {
    return (o === null || o === undefined);
  }

  /**
   * Returns a deep clone of the given object
   * @param src the object to be deep copied
   */
  public static CloneObject(src: Object): Object {
    let objStr = JSON.stringify(src, (k, v) => {
      /*
       * This is necessary because the runtime HUTT serializer sends over data
       * in associative containers and javascript does not have a definition for handling them.
       * This code snippet forces them to be interpreted as standard arrays for the purpose
       * of serialization.
       */
      if (v instanceof Uint32Array || v instanceof Float64Array || v instanceof Float32Array) {
        return Array.prototype.slice.call(v);
      }
      return v;
    });
    return JSON.parse(objStr);
  }

  /**
   * Safely calls Window.ClearTimeout for the provided handle, which was previously created using Window.SetTimeout.
   * Returns null so that you can clear the timeout and assign in one statement, e.g.:
   * myTimeout = MiscUtil.ClearTimeout(myTimeout);
   */
  public static ClearTimeout(handle?: number): number {
    if (!MiscUtil.IsNullOrUndefined(handle)) {
      window.clearTimeout(handle);
    }
    return null;
  }
}

export { MiscUtil };
